import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

import stripHtml from '../../scripts/StripHtml.js';

//import components
import ShowMoreButton from './ShowMoreButton.js';

// img
import fieldRed from '../../assets/icons/field-red.svg';
import fieldGreen from '../../assets/icons/field-green.svg';
import fieldYellow from '../../assets/icons/field-yellow.svg';
import fieldViolet from '../../assets/icons/field-violet.svg';

import typeBook from '../../assets/icons/type-book.svg';
import typeBookContent from '../../assets/icons/book-content.svg';
import typeSpectacle from '../../assets/icons/type-spectacle.svg';
import typeMovie from '../../assets/icons/type-movie.svg';
import typeRadio from '../../assets/icons/type-radio.svg';
import typeTV from '../../assets/icons/type-tv.svg';
import typeJournalItem from '../../assets/icons/cards-light.svg';

import event from '../../assets/icons/event-accent.svg';
import eventSeries from '../../assets/icons/event-series-accent.svg';
import work from '../../assets/icons/work-accent.svg';
import journal from '../../assets/icons/journal-accent.svg';
// import journalNumber from '../../assets/icons/journal-number-accent.svg';
import records from '../../assets/icons/records-accent.svg';
import institution from '../../assets/icons/institution-accent.svg';
import place from '../../assets/icons/place-accent.svg';
import series from '../../assets/icons/series-accent.svg';
import person from '../../assets/icons/person-accent.svg';

import { getTextMetadataDataTransformed } from '../../scripts/TextMetadata.js';

class ListItem extends Component {
    constructor() {
        super();
        this.state = {
            isOpened: false
        };
    };

    componentDidMount() {
        window.addEventListener("resize", this.updateFieldsOpened.bind(this));
    };

    componentDidUpdate(prevProps, prevState) {
        const {isMobile, isFieldsOpen, headings, secondaryHeadings} = this.props;

        isFieldsOpen(this.state.isOpened);

        const totalHeadingsLength = headings ? headings.length : 0 + secondaryHeadings ? secondaryHeadings.length : 0;

        if (isMobile !== prevProps.isMobile && !isMobile && totalHeadingsLength <= 2) {
            this.setState({isOpened: false});
        }
    };

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateFieldsOpened.bind(this));
        this.props.isFieldsOpen(false);
    };

    toggleOpen = () => {
        this.setState({isOpened: !this.state.isOpened});
    };

    updateFieldsOpened = () => {
        const {isMobile, isFieldsOpen} = this.props;

        if (isMobile && this.state.isOpened) {
            isFieldsOpen(true);
        }
    };

    isRecord = (type) => ['records', 'journal-item', 'spectacle', 'movie', 'radio', 'television', 'book', 'content'].includes(type);

    getImgField = (label, imgClass) => {
        switch (label) {
            case 'polish-literature':
                return <img src={fieldRed} alt="" className={imgClass}/>;
            case 'literature-theory':
                return <img src={fieldViolet} alt="" className={imgClass}/>;
            case 'foreign-literature':
                return <img src={fieldYellow} alt="" className={imgClass}/>;
            case 'movie-theatre-rtv':
                return <img src={fieldGreen} alt="" className={imgClass}/>;
            default:
                return;
        }
    };

    getImgTitle = (type) => {
        const { clang } = this.props;
        switch (type) {
            case 'spectacle':
                return <img src={typeSpectacle} alt={lang[clang].alt.spectacle} className="results__list-item__img"/>;
            case 'movie':
                return <img src={typeMovie} alt={lang[clang].alt.movie} className="results__list-item__img"/>;
            case 'book':
                return <img src={typeBook} alt={lang[clang].alt.book} className="results__list-item__img"/>;
            case 'content':
                return <img src={typeBookContent} alt={lang[clang].alt.content} className="results__list-item__img"/>;
            case 'person':
                return <img src={person} alt={lang[clang].alt.person} className="results__list-item__img"/>;
            case 'series':
                return <img src={series} alt={lang[clang].alt.series} className="results__list-item__img"/>;
            case 'event-series':
                return <img src={eventSeries} alt={lang[clang].alt.event_series} className="results__list-item__img"/>;
            case 'event':
                return <img src={event} alt={lang[clang].alt.event} className="results__list-item__img"/>;
            case 'institution':
                return <img src={institution} alt={lang[clang].alt.institution} className="results__list-item__img"/>;
            case 'creative-work':
                return <img src={work} alt={lang[clang].alt.creative_work} className="results__list-item__img"/>;
            case 'journal':
                return <img src={journal} alt={lang[clang].alt.journal} className="results__list-item__img"/>;
            case 'journal-item':
                return <img src={typeJournalItem} alt={lang[clang].alt.journal_item} className="results__list-item__img"/>;
            case 'radio':
                return <img src={typeRadio} alt={lang[clang].alt.radio} className="results__list-item__img"/>;
            case 'television':
                return <img src={typeTV} alt={lang[clang].alt.tv} className="results__list-item__img"/>;
            case 'place':
                return <img src={place} alt={lang[clang].alt.place} className="results__list-item__img"/>;
            default:
                return;
        }
    };

    getRelatedImg = (type) => {
        const { clang } = this.props;
        switch (type) {
            case 'records':
                return <img src={records} alt={lang[clang].alt.record} className="results__list-item__record__img"/>;
            case 'journal':
                return <img src={journal} alt={lang[clang].alt.journal} className="results__list-item__record__img"/>;
            case 'journal-item':
                return;
            case 'event-series':
                return <img src={eventSeries} alt={lang[clang].alt.event_series} className="results__list-item__record__img"/>;
            case 'institution':
                return <img src={institution} alt={lang[clang].alt.institution} className="results__list-item__record__img"/>;
            case 'series':
                return <img src={series} alt={lang[clang].alt.series} className="results__list-item__record__img"/>;
            case 'creative-work':
                return <img src={work} alt={lang[clang].alt.creative_work} className="results__list-item__record__img"/>;
            case 'event':
                return <img src={event} alt={lang[clang].alt.event} className="results__list-item__record__img"/>;
            case 'place':
                return <img src={institution} alt={lang[clang].alt.place} className="results__list-item__record__img"/>;
            default:
                return;
        }
    };

    getLeftContent = () => {
        const {clang, type, subtype, linkedText, transliterated} = this.props;

        if (this.isRecord(type)) {
            return (
            <div className="results__list-item__header--left">
                <span className="results__list-item__header-type">
                    {lang[clang].item.types[type.toLowerCase()]}
                </span>

                {subtype && (
                    <div className="results__list-item__header-subtype">
                        {subtype}
                    </div>
                )}
            </div>
        ) }

        return (
            <div className="results__list-item__header--left">
                  {this.getImgTitle(type)}
                  <Link to={`/item/${type.toLowerCase()}/${linkedText.link}`} title={stripHtml(linkedText.label)}>
                    <span 
                        dangerouslySetInnerHTML={{__html: getTextMetadataDataTransformed(linkedText.label)}}
                    />
                    { transliterated && (
                        <sup className="results__list-item__header-sup">t</sup>
                    )}
                  </Link>
               </div>
        )
    };

    getHeadingsContent = (newHeadings, isOpened) => {
        const {clang, isMobile} = this.props;

        return <div className="results__list-item__header--right">
                  {(newHeadings && newHeadings.length > 0 && !isMobile) && (
                      newHeadings.slice(0, 2).map((heading, index) => this.getHeadingItem(heading, index))
                  )}

                  {(newHeadings && (newHeadings.length > 2 || (isMobile && newHeadings.length > 0))) && (
                      <div className="results__list-item__field">
                          <button 
                                className="results__list-item__field__show-all" 
                                onClick={() => this.toggleOpen()}
                            >

                                {!isMobile && (
                                    <span>{lang[clang].show_all}</span>
                                ) }

                                {isMobile && (
                                    <span>
                                        <img 
                                        src={fieldRed} 
                                        alt="mobile-list-item-field" 
                                        className="results__list-item__field-elem__img"
                                    />
                                    {lang[clang].results.show_fields}
                                    </span>
                                )}
                          </button>

                          {isOpened && (
                              <div className="results__list-item__field__more">
                                  <div className="field-more__header">
                                    <p className="field-more__header-text">{lang[clang].results.field_section}</p>
                                    <button 
                                        onClick={() => this.toggleOpen()} 
                                        className="field-more__close" 
                                        title={lang[clang].close}
                                    />
                                  </div>
                                  <div className="field-more__list">
                                      {newHeadings.map((heading, index) => this.getHeadingItem(heading, index))}
                                  </div>
                              </div>
                            )}
                      </div>
                    )}
                </div>;
    };

    getHeadingItem = (heading, index) => {
        const {clang} = this.props;
        const domain = heading.filter(headingItem => headingItem.entityType === 'domain')[0];
        const headingElem = heading.filter(headingItem => headingItem.entityType !== 'domain')[0];

        if (domain && headingElem) {
            return <div key={index} className="results__list-item__field">
                      <div className="results__list-item__field-elem">
                          {this.getImgField(domain.label, "results__list-item__field-elem__img")}
                          <span>{lang[clang].results.field}: </span>
                          <a title={lang[clang].field_types[domain.label]} href={domain.link}>{lang[clang].field_types[domain.label]}</a>
                      </div>
                      <div className="results__list-item__field-elem">
                          {headingElem.isSecondary ? <span>{lang[clang].results.headings_secondary}: </span> : <span>{lang[clang].results.headings}: </span>}
                          <a title={headingElem.label} href={headingElem.link} dangerouslySetInnerHTML={{__html: headingElem.label}}></a>
                      </div>
                  </div>;
        }

        return;
    };

    getHeadingMoreListItem = (heading, index) => {
        const {clang} = this.props;
        const domain = heading.filter(headingItem => headingItem.entityType === 'domain')[0];
        const headingElem = heading.filter(headingItem => headingItem.entityType !== 'domain')[0];

        if (domain && headingElem) {
            return  <li className="field-more__list-item" key={index}>
                        <div className="field-more__list-item__field-elem">
                            {this.getImgField(domain.label, "field-more__list-item__field-elem__img")}
                            <span>{lang[clang].results.field}: </span>
                            <a title={lang[clang].field_types[domain.label]} href={domain.link}>{lang[clang].field_types[domain.label]}</a>
                        </div>
                        <div className="field-more__list-item__field-elem">
                            {headingElem.isSecondary ? <span>{lang[clang].results.headings_secondary}: </span> : <span>{lang[clang].results.headings}: </span>}
                            <a title={headingElem.label} href={headingElem.link} dangerouslySetInnerHTML={{__html: headingElem.label}}></a>
                        </div>
                    </li>;
        }

        return;
    };

    render() {
        const { type, where, linkedText, annotations, clang, linkedFilesAndRecordsCounters, headings, secondaryHeadings,
                allNames, subtype, edition, locationAndDate, organizors, awards, journalSubtitle, additionTo, contains,
                triggerInstitution, publishingHouse, location, authors, seriesType, sources} = this.props;
        const { isOpened } = this.state;

        const newHeadings = secondaryHeadings && headings ? headings.concat(secondaryHeadings.map(heading => heading.map(h1 => { return {...h1, isSecondary: true}}))) : headings;
        const mainName = allNames ? allNames.filter(name => name.type === 'main-name').concat(allNames.filter(name => name.type === 'main-name')) : false;
        const alias = allNames ? allNames.filter(name => name.type === 'alias') : false;
        const familyName = allNames ? allNames.filter(name => name.type === 'family-name') : false;
        const monasticName = allNames ? allNames.filter(name => name.type === 'monastic-name') : false;
        const codename = allNames ? allNames.filter(name => name.type === 'codename') : false;
        const otherName = allNames ? allNames.filter(name => name.type === 'other-last-name-or-first-name') : false;

        const itemInfo = [
                            {label: 'mainName', value: mainName},
                            {label: 'otherName', value: otherName},
                            {label: 'seriesType', value: seriesType},
                            {label: 'authors', value: authors},
                            {label: 'sources', value: sources},
                            {label: 'journalSubtitle', value: journalSubtitle},
                            {label: 'additionTo', value: additionTo},
                            {label: 'contains', value: contains},
                            {label: 'triggerInstitution', value: triggerInstitution},
                            {label: 'publishingHouse', value: publishingHouse},
                            {label: 'alias', value: alias},
                            {label: 'familyName', value: familyName},
                            {label: 'monasticName', value: monasticName},
                            {label: 'codename', value: codename},
                            {label: 'subtypeEvent', value: type === 'event' ? subtype : false},
                            {label: 'subtypeEventSeries', value: type === 'event-series' ? subtype : false},
                            {label: 'edition', value: edition},
                            {label: 'locationAndDateEvent', value: type === 'event' ? locationAndDate : false},
                            {label: 'organizors', value: organizors},
                            {label: 'awards', value: awards},
                            {label: 'subtype', value: type === 'institution' ? subtype : false},
                            {label: 'location', value: location},
                            {label: 'annotation', value: getTextMetadataDataTransformed(annotations)},
                            {label: 'phrase', value: where ? where.map((item, index) => lang[clang].item[item] ? {label: `${index !== 0 ? ' ' : ''}${lang[clang].item[item]}`} : {label: item}).filter(item => item) : false}]
                            .filter(item => Array.isArray(item.value) ? item.value.length : item.value);

        return (
            <li className={`results__list-item ${!this.isRecord(type) ? 'card' : ''}`}>
                <div className="results__list-item__header">
                    {this.getLeftContent()}
                    {this.isRecord(type) && this.getHeadingsContent(newHeadings, isOpened)}
                </div>
                <div className="results__list-item__content">
                    {!this.isRecord(type) && this.getHeadingsContent(newHeadings, isOpened)}
                    {this.isRecord(type) &&
                        <div className="results__list-item__content-title">
                            <div className="results__list-item__img-container">{this.getImgTitle(type)}</div>
                            <Link to={`/item/${type.toLowerCase()}/${linkedText.link}`}
                                  title={stripHtml(linkedText.label)}
                                  className="results__list-item__title"
                                  dangerouslySetInnerHTML={{__html: getTextMetadataDataTransformed(linkedText.label)}}>
                            </Link>
                        </div>}
                    {itemInfo.map((item, index) =>
                        <div className="results__list-item__info" key={index}>
                            {lang[clang].item[item.label]}: 
                            {Array.isArray(item.value) ?
                                item.value.map((itemElem, elemIndex) => 
                                    <strong key={elemIndex} dangerouslySetInnerHTML={{__html: elemIndex !== item.value.length - 1 ? itemElem.label + ',' : itemElem.label}}></strong>)
                                 : <strong dangerouslySetInnerHTML={{__html: item.value}}></strong>}
                        </div>)}
                </div>
                {((linkedFilesAndRecordsCounters.length > 0 && !this.isRecord(type)) || this.isRecord(type)) &&
                    <div className="results__list-item__footer-separator">
                        <div className="results__list-item__footer-separator--left">
                        </div>
                        <div className="results__list-item__footer-separator--right">
                        </div>
                    </div>}
                <div className="results__list-item__footer">
                    <div className="results__list-item__footer--left">
                        {linkedFilesAndRecordsCounters.length > 0 &&
                            <div className="results__list-item__records">
                                {lang[clang].results.related_record}:
                                {linkedFilesAndRecordsCounters.map((relatedItem, index) =>
                                    <div key={index} className="results__list-item__record">
                                        {this.getRelatedImg(relatedItem.type)}
                                        <span className="results__list-item__record-name">
                                            {lang[clang].item.item_types[relatedItem.type]}
                                        </span>
                                        :
                                        <span> {relatedItem.count}</span>
                                    </div>)}
                            </div>}
                    </div>
                    <div className="results__list-item__footer--right">
                        <ShowMoreButton url={`/item/${type.toLowerCase()}/${linkedText.link}`}/>
                    </div>
                </div>
          </li>
      );
    }
};

ListItem.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ListItem);



// WEBPACK FOOTER //
// ./src/components/simple-search-results/SimpleSearchResultsListItem.js